import editDeal from '../../../../api/deals/editDeal';
import setStep from '../../../../api/deals/setStep';
import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import Select from '../../../../components/Select/Select';
import SelectDealPaymentStatuses from '../../../../components/Selects/selectDealPaymentStatuses';
import {
  DEAL_STATUS_CAR_ISSUED,
  DEAL_STEPS,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_CONTRACT,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_POLES,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  DOCUMENT_TYPES_TECH_PASSPORT,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import generateAllowedDocumentsJson from '../../../../utils/generateAllowedDocumentsJson';

const CarDelivery = ({ loading, deal, setLoading, onSuccess }) => {
  const onCarDeliverySubmit = async (values) => {
    if (!values?.status) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ ÑÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸');
      return;
    }
    setLoading(true);
    try {
      await editDeal({
        id: deal?.id,
        dealId: deal?.id,
        statusId: values?.status?.value,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES,
          DOCUMENT_TYPES_GUARANTEE_LETTER,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_TECH_PASSPORT,
          DOCUMENT_TYPES_CONTRACT,
          DOCUMENT_TYPES_POLES,
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
        ]),
      });

      await setStep({ dealId: deal?.id, step: DEAL_STEPS.FINISH });
      setLoading(false);
      return onSuccess();
    } catch (e) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ ÑÐ¼ÐµÐ½Ðµ ÑÑÐ°ÑÑÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸');
      setLoading(false);
      return;
    }
  };

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <HookForm
          title={'ÐÑÐ´Ð°ÑÐ° Ð¢Ð¡'}
          grid={{ display: 'grid', gap: 20 }}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
          inputs={[
            {
              label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
              name: 'status',
              component: Select,
              options: [
                {
                  value: DEAL_STATUS_CAR_ISSUED,
                  label: 'ÐÐ°ÑÐ¸Ð½Ð° Ð²ÑÐ´Ð°Ð½Ð°',
                },
              ],
              required: true,
            },
          ]}
          onSubmit={onCarDeliverySubmit}
          loading={loading}
        />
      </div>
    </>
  );
};

export default CarDelivery;
